




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import { TokenUser } from '../TokenUser';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { useAuth } from '@/oauth';

@Component({
  name: 'DapperLoginButton',
  components: {}
})
export default class DapperLoginButtonComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: false })
  public signUpInsteadOfSignIn: boolean;

  // public reactive member variables available to the html template
  public get buttonImage(): string { return this.signUpInsteadOfSignIn ? '/images/btn_dapper_signin_normal_web@2x.png' : '/images/btn_dapper_signin_normal_web@2x.png' }

  // public functions available to the html template
  public async onClick() {

    this.$emit('buttonClicked')

    utils_tracker.track('User ClickedLogin Dapper', {})

    // Redirects to Auth0 login page
    useAuth(this).loginWithRedirect()
    // useAuth(this).logout()

    

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template

  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
